<template>
    <div>

        <config-main-title>
            SUS - Autorizadores
        </config-main-title>

        <div class="form-row mb-3">
            <div class="col col-12 col-md-6 d-flex flex-column">
                <az-input icon="fas fa-search" v-model="search">
                    <!-- 
                    <template v-slot:buttonposb>
                        <importacao service="unidade_medidas" @refresh="load()" />
                    </template>
                    -->
                </az-input>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'A'">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'T'">
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="incluir ()">
                    Incluir Autorizador
                </button>
            </div>
        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                msg="Nenhum autorizador identificado." 
                icon="fas fa-search" />
		</div>

        <div v-if="lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_unidade_operacao_autorizador ? '' : 'Novo' }}
                            Autorizador
                            {{ item && item.id_unidade_operacao_autorizador ? '#' + item.id_unidade_operacao_autorizador : '' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Unidade"
                                    :validate="validate"
                                    required
                                    :optionsList="$store.state.unidade.unidade_operacaos"
                                    optionsData="id_unidade_operacao"
                                    type="select"
                                    placeholder="Selecione a Unidade..."
                                    v-model="item.id_unidade_operacao" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Nome do Autorizador"
                                    :validate="validate"
                                    required
                                    v-model="item.st_sus_nome_autorizador" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="CNS do Autorizador"
                                    type="cns"
                                    :validate="validate"
                                    required
                                    v-model="item.st_sus_cns_autorizador" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Número do Conselho do Autorizador"
                                    :validate="validate"
                                    v-model="item.st_sus_numero_autorizador" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    type="textarea"
                                    label="Observação"
                                    :validate="validate"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="unidadeOperacaoAutorizador" :id="item.id_unidade_operacao_autorizador" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_unidade_operacao_autorizador ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

    },

    methods: { 
        
        incluir () { 
            this.validate = false;

            let item = {
                id_unidade_operacao_autorizador: null, 
                id_unidade_operacao: null, 
                st_sus_nome_autorizador: "", 
                st_sus_cns_autorizador: "", 
                in_regra_ordem: 100, 
                fl_ativo: true, 
            };

            this.editar (item);
        },

        load () { 
            this.$util.load(this, { 
                service:'unidade_operacao_autorizadores',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },

        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'unidade_operacao_autorizadores',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'unidade_operacao_autorizadores',
                dados: item,
            });

        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "SUS - Autorizadores", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>